/* The Detail Reserve — shared behavior for every TDR template.
   Menu, reveal motion, call/text tracking and the review layer.
   Progressive enhancement only: pages work without it. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- First-touch lead source (read by the request form on any later page) ----
  try {
    if (!sessionStorage.getItem('tdr-src')) {
      const q = new URLSearchParams(location.search);
      const utm = ['utm_source', 'utm_medium', 'utm_campaign'].map((k) => q.get(k)).filter(Boolean).join(' / ');
      let ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (_) { /* bad referrer */ }
      sessionStorage.setItem('tdr-src', JSON.stringify({ utm, ref: ref && ref !== location.hostname ? ref : '', landing: location.pathname }));
    }
    // Google Ads click ID, kept 90 days so a later visit still credits the ad (used for offline conversion import).
    const click = ['gclid', 'gbraid', 'wbraid'].map((k) => new URLSearchParams(location.search).get(k) && `${k}:${new URLSearchParams(location.search).get(k)}`).find(Boolean);
    if (click) localStorage.setItem('tdr-click', JSON.stringify({ id: click, at: Date.now() }));
  } catch (_) { /* storage unavailable */ }

  // ---- Mobile menu ------------------------------------------------------------
  const header = $('[data-header]');
  const btn = header && $('[data-menu]', header);
  if (btn) {
    const set = (open) => {
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      header.classList.toggle('is-open', open);
    };
    btn.addEventListener('click', () => set(btn.getAttribute('aria-expanded') !== 'true'));
    $('#drawer')?.addEventListener('click', (e) => { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && header.classList.contains('is-open')) { set(false); btn.focus(); } });
  }

  // ---- "Get started" starts the builder on this page when there is one ----------
  // Otherwise jump to this page's service picker or request form.
  const startTarget = ['build', 'services', 'request'].find((id) => document.getElementById(id));
  if (startTarget) {
    $$('a[data-start]').forEach((a) => { if (!a.getAttribute('href').startsWith('#')) a.setAttribute('href', `#${startTarget}`); });
  }

  // ---- Reveal motion (frames are observed; the image inside is what animates) ---
  const animated = $$('[data-reveal], [data-curtain]');
  if (reduce || !('IntersectionObserver' in window)) {
    animated.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    animated.forEach((el) => io.observe(el));
  }

  // ---- Phone bar steps aside while someone is typing ------------------------------
  const bar = $('[data-bar]');
  if (bar) {
    document.addEventListener('focusin', (e) => { if (e.target.matches('input, select, textarea')) bar.classList.add('is-hidden'); });
    document.addEventListener('focusout', () => bar.classList.remove('is-hidden'));
  }

  // Call and text clicks are measured once, in tdr-track.js.

  // ---- Review layer (only rendered while the theme setting is on) ------------------
  if (!document.body.classList.contains('has-review')) return;
  const notes = $$('[data-note]');
  if (!notes.length) return;
  const panel = document.createElement('aside');
  panel.className = 'rv-panel';
  panel.id = 'rv-panel';
  panel.setAttribute('aria-label', 'Review notes');
  panel.innerHTML = '<h2>Review notes</h2><p>Placeholders and owner decisions. Hidden sections appear while notes are on. Turn off in Theme settings → The Detail Reserve before launch.</p><ol></ol>';
  notes.forEach((el, i) => {
    if (!el.id) el.id = `rv-note-${i + 1}`;
    const pin = document.createElement('span');
    pin.className = 'rv-pin'; pin.textContent = i + 1; pin.title = el.dataset.note; pin.setAttribute('aria-hidden', 'true');
    el.append(pin);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${el.id}`; a.textContent = el.dataset.note;
    li.append(a); $('ol', panel).append(li);
  });
  const toggle = document.createElement('button');
  toggle.type = 'button'; toggle.className = 'rv-toggle'; toggle.setAttribute('aria-controls', 'rv-panel');
  toggle.innerHTML = `<span>Review notes</span><b>${notes.length}</b>`;
  const set = (on) => {
    document.documentElement.classList.toggle('rv-on', on);
    panel.classList.toggle('is-open', on);
    toggle.setAttribute('aria-expanded', String(on));
    try { localStorage.setItem('tdr-rv', on ? '1' : '0'); } catch (_) { /* no storage */ }
  };
  toggle.addEventListener('click', () => set(!document.documentElement.classList.contains('rv-on')));
  document.body.append(panel, toggle);
  let saved = null;
  try { saved = localStorage.getItem('tdr-rv'); } catch (_) { /* no storage */ }
  set(saved === '1');
})();
